var map = {
	"./ghost.jpg": "c9b2",
	"./logo.jpeg": "dc7c",
	"./pc-list-one-add.jpg": "f1c1",
	"./pc-list-one-cart.jpg": "d19c",
	"./pc-list-two-add.jpg": "d97a",
	"./pc-list-two-cart.jpg": "09da",
	"./pc-template-category-advert.jpg": "85fd",
	"./pc-template-category-base.jpg": "e784"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "e107";